import type { GetControlByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';
import { useHasPermissionQuery } from 'src/rbac/useHasPermission';

import { useIsModuleEnabled } from '@/hooks/useIsModuleEnabled';

import InternalAuditPerformanceRatingRegister from './InternalAuditPerformanceRatingRegister';
import OversightPerformanceRatingRegister from './OversightPerformanceRatingRegister';
import PerformanceRatingRegister from './PerformanceRatingRegister';

type Props = {
  control: GetControlByIdQuery['control'][number];
};

const Tab: FC<Props> = ({ control }) => {
  const oversightEnabled = useIsModuleEnabled(
    'assessment.subModules.oversight_register_and_findings'
  );
  const internalAuditEnabled = useIsModuleEnabled('internal_audit_entity');
  const {
    hasPermission: canViewCompliance,
    loading: canViewComplianceLoading,
  } = useHasPermissionQuery('read:oversight_assessment', control);
  const {
    hasPermission: canViewInternalAudit,
    loading: canViewInternalAuditLoading,
  } = useHasPermissionQuery('read:internal_audit_report', control);

  return (
    <>
      <PerformanceRatingRegister control={control} />
      {oversightEnabled && canViewCompliance && !canViewComplianceLoading && (
        <OversightPerformanceRatingRegister control={control} />
      )}
      {internalAuditEnabled &&
        canViewInternalAudit &&
        !canViewInternalAuditLoading && (
          <InternalAuditPerformanceRatingRegister control={control} />
        )}
    </>
  );
};

export default Tab;
